(function () {
  var wrapper = document.querySelector('.mh-wrapper');
  if (!wrapper) return;

  var megaMenus = wrapper.querySelectorAll('[data-mh-megamenu]');
  var browseToggle = wrapper.querySelector('[data-mh-browse-toggle]');
  var wishlistToggle = wrapper.querySelector('[data-mh-wishlist-toggle]');
  var navItems = wrapper.querySelectorAll('[data-mh-nav-item]');

  /* Drawer + overlay now live OUTSIDE .mh-wrapper (see liquid file), so
     query them at document level, not scoped to wrapper. */
  var wishlistDrawer = document.querySelector('[data-mh-wishlist-drawer]');
  var overlay = document.querySelector('[data-mh-overlay]');
  var wishlistClose = document.querySelector('[data-mh-wishlist-close]');
  var wishlistList = document.querySelector('[data-mh-wishlist-list]');

  var TEXT = window.mhWishlistText || {
    addLabel: 'Add to Wishlist',
    removeLabel: 'Remove from Wishlist',
    viewLabel: 'View',
    emptyText: 'Your wishlist is empty.',
    moneyFormat: '${{amount}}',
    hoverColor: '#f5b400'
  };

  var HEART_PATH = 'M12 21C12 21 4 14.5 4 9.5C4 6.6 6.2 4.5 9 4.5C10.7 4.5 12 5.3 12 5.3C12 5.3 13.3 4.5 15 4.5C17.8 4.5 20 6.6 20 9.5C20 14.5 12 21 12 21Z';

  /* ================================================================
     MEGA MENU (independent panel per nav link)
     Every trigger — the "Browse Categories" button, or any nav item
     that carries a data-menu-group value — has its OWN [data-mh-megamenu]
     element with a matching data-menu-group. openMega() just shows the
     one whose group matches and hides the rest; there is no column
     filtering inside a shared panel anymore.
     ================================================================ */
  var closeTimer = null;
  var currentGroup = null;

  function getMegaMenu(group) {
    var target = null;
    megaMenus.forEach(function (mm) {
      if (mm.getAttribute('data-menu-group') === group) target = mm;
    });
    return target;
  }

  function hideAllMegaMenus() {
    megaMenus.forEach(function (mm) { mm.hidden = true; });
  }

  function setActiveNavItem(activeItem) {
    navItems.forEach(function (item) {
      item.classList.toggle('mh-open', item === activeItem);
    });
  }

  function openMega(group, activeItem) {
    group = group || '';
    var target = getMegaMenu(group);
    if (!target) return;

    closeWishlist();
    clearTimeout(closeTimer);
    hideAllMegaMenus();
    target.hidden = false;
    currentGroup = group;
    overlay.hidden = false;
    overlay.classList.remove('mh-overlay--dim'); /* mega menu: no page dimming */
    browseToggle.setAttribute('aria-expanded', String(group === ''));
    setActiveNavItem(activeItem || null);
  }

  function closeMega() {
    hideAllMegaMenus();
    if (wishlistDrawer.hidden) {
      overlay.hidden = true;
      overlay.classList.remove('mh-overlay--dim');
    }
    browseToggle.setAttribute('aria-expanded', 'false');
    setActiveNavItem(null);
    currentGroup = null;
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMega, 200);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  function toggleMega() {
    if (currentGroup !== '') {
      openMega('', null);
    } else {
      closeMega();
    }
  }

  if (browseToggle) {
    browseToggle.addEventListener('click', toggleMega);
    browseToggle.addEventListener('mouseenter', function () {
      openMega('', null);
    });
    browseToggle.addEventListener('mouseleave', scheduleClose);
  }

  /* Nav items with a Mega menu key open their OWN panel on hover. Nav
     items WITHOUT a key still need to cancel/schedule the close timer
     on hover — otherwise moving the mouse across a plain link while a
     neighboring item's panel is open causes it to flicker open/closed. */
  navItems.forEach(function (item) {
    var group = item.getAttribute('data-menu-group');

    if (group) {
      item.addEventListener('mouseenter', function () {
        openMega(group, item);
      });
    } else {
      item.addEventListener('mouseenter', cancelClose);
    }
    item.addEventListener('mouseleave', scheduleClose);
  });

  megaMenus.forEach(function (mm) {
    mm.addEventListener('mouseenter', cancelClose);
    mm.addEventListener('mouseleave', scheduleClose);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMega(); closeWishlist(); }
  });

  /* ---------- Predictive search ---------- */
  var input = wrapper.querySelector('[data-mh-search-input]');
  var results = wrapper.querySelector('[data-mh-search-results]');
  var submitBtn = wrapper.querySelector('[data-mh-search-submit]');
  var searchTimer;

  function goToSearch() {
    var q = input.value.trim();
    if (!q) return;
    window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  }

  if (submitBtn) submitBtn.addEventListener('click', goToSearch);
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') goToSearch();
    });

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(searchTimer);
      if (query.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () { runPredictiveSearch(query); }, 250);
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        results.hidden = true;
      }
    });
  }

  function runPredictiveSearch(query) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        results.innerHTML = '';
        if (!products.length) {
          results.innerHTML = '<div class="mh-search-empty">No products found for "' + escapeHtml(query) + '"</div>';
          results.hidden = false;
          return;
        }
        products.forEach(function (p) {
          var a = document.createElement('a');
          a.href = p.url;
          var img = p.featured_image ? '<img src="' + p.featured_image.url + '" alt="">' : '';
          a.innerHTML = img + '<span>' + escapeHtml(p.title) + '</span>';
          results.appendChild(a);
        });
        results.hidden = false;
      })
      .catch(function () { results.hidden = true; });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ================================================================
     WISHLIST SYSTEM
     Stored client-side in localStorage as an array of:
     { id, handle, title, price, image, url }
     ================================================================ */

  var WISHLIST_KEY = 'mh_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isInWishlist(id) {
    return getWishlist().some(function (item) { return String(item.id) === String(id); });
  }

  function addToWishlist(product) {
    var list = getWishlist();
    if (!list.some(function (i) { return String(i.id) === String(product.id); })) {
      list.push(product);
      saveWishlist(list);
    }
    refreshWishlistUI();
  }

  function removeFromWishlist(id) {
    var list = getWishlist().filter(function (i) { return String(i.id) !== String(id); });
    saveWishlist(list);
    refreshWishlistUI();
  }

  function toggleWishlistItem(product, btn) {
    if (isInWishlist(product.id)) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(product);
    }
    if (btn) setButtonState(btn, isInWishlist(product.id));
  }

  function setButtonState(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? TEXT.removeLabel : TEXT.addLabel;
    btn.setAttribute('aria-label', label);
    if (btn.hasAttribute('data-mh-wishlist-pdp')) {
      var textEl = btn.querySelector('[data-mh-wishlist-pdp-text]');
      if (textEl) textEl.textContent = label;
    }
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var format = TEXT.moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, parts[0] + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  /* ---- Header badges + drawer rendering ---- */
  function refreshWishlistUI() {
    var list = getWishlist();

    /* Update every count badge on the page: desktop icon + mobile icon */
    document.querySelectorAll('[data-mh-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });

    if (wishlistToggle) wishlistToggle.classList.toggle('is-active', list.length > 0);
    var mobileIcon = document.querySelector('[data-mh-mobile-wishlist]');
    if (mobileIcon) mobileIcon.classList.toggle('is-active', list.length > 0);

    if (wishlistList) {
      wishlistList.innerHTML = '';
      if (!list.length) {
        var empty = document.createElement('p');
        empty.className = 'mh-wishlist-empty';
        empty.textContent = TEXT.emptyText;
        wishlistList.appendChild(empty);
      } else {
        list.forEach(function (item) {
          wishlistList.appendChild(buildWishlistRow(item));
        });
      }
    }

    /* Sync every wishlist heart button currently rendered on the page
       (product cards + product page button) */
    document.querySelectorAll('[data-mh-wishlist-btn]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (id) setButtonState(btn, isInWishlist(id));
    });
  }

  function buildWishlistRow(item) {
    var row = document.createElement('div');
    row.className = 'mh-wishlist-row';

    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="" loading="lazy">'
      : '';

    row.innerHTML =
      '<a class="mh-wishlist-row-media" href="' + item.url + '">' + imgHtml + '</a>' +
      '<div class="mh-wishlist-row-info">' +
        '<a class="mh-wishlist-row-title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>' +
        '<span class="mh-wishlist-row-price">' + formatMoney(item.price) + '</span>' +
        '<div class="mh-wishlist-row-actions">' +
          '<a href="' + item.url + '" class="mh-wishlist-row-view">' + escapeHtml(TEXT.viewLabel) + '</a>' +
          '<button type="button" class="mh-wishlist-row-remove" aria-label="Remove">&times;</button>' +
        '</div>' +
      '</div>';

    row.querySelector('.mh-wishlist-row-remove').addEventListener('click', function () {
      removeFromWishlist(item.id);
    });

    return row;
  }

  /* ---- Drawer open/close (works from desktop OR mobile icon) ---- */
  function openWishlist() {
    closeMega();
    wishlistDrawer.hidden = false;
    overlay.hidden = false;
    overlay.classList.add('mh-overlay--dim'); /* wishlist drawer: dim the page */
  }
  function closeWishlist() {
    wishlistDrawer.hidden = true;
    var anyMegaOpen = false;
    megaMenus.forEach(function (mm) { if (!mm.hidden) anyMegaOpen = true; });
    if (!anyMegaOpen) {
      overlay.hidden = true;
      overlay.classList.remove('mh-overlay--dim');
    }
  }
  function toggleWishlistDrawer(e) {
    if (e) e.preventDefault();
    if (wishlistDrawer.hidden) openWishlist(); else closeWishlist();
  }

  if (wishlistToggle) wishlistToggle.addEventListener('click', toggleWishlistDrawer);
  if (wishlistClose) wishlistClose.addEventListener('click', closeWishlist);
  if (overlay) overlay.addEventListener('click', function () { closeMega(); closeWishlist(); });

  /* ---- Heart button factory ---- */
  function createHeartButton(extraClass) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mh-wishlist-btn' + (extraClass ? ' ' + extraClass : '');
    btn.setAttribute('data-mh-wishlist-btn', '');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<path d="' + HEART_PATH + '"></path>' +
      '</svg>';
    return btn;
  }

  /* ---- Product data cache (handle -> product json) ---- */
  var productCache = {};
  function fetchProductByHandle(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productCache[handle] = data;
        return data;
      })
      .catch(function () { return null; });
  }

  function productToWishlistItem(product, url) {
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      price: (product.price !== undefined) ? product.price : (product.variants && product.variants[0] ? product.variants[0].price : 0),
      image: product.featured_image || (product.images && product.images[0]) || '',
      url: url || ('/products/' + product.handle)
    };
  }

  /* ---- Inject heart buttons onto product cards (collection/search grids) ---- */
  function findCardContainer(link) {
    var el = link;
    for (var i = 0; i < 5 && el && el !== document.body; i++) {
      if (el.tagName === 'LI' || (el.className && typeof el.className === 'string' && el.className.indexOf('card') !== -1)) {
        return el;
      }
      el = el.parentElement;
    }
    return link.parentElement || link;
  }

  function injectCardButtons(root) {
    var scope = root || document;
    if (scope.nodeType !== 1 && scope !== document) return;
    var links = scope.querySelectorAll ? scope.querySelectorAll('a[href*="/products/"]') : [];

    links.forEach(function (link) {
      if (link.closest('[data-mh-wishlist-drawer]') || link.closest('.mh-search-results')) return;

      var card = findCardContainer(link);
      if (!card || card.hasAttribute('data-mh-wishlist-attached')) return;
      card.setAttribute('data-mh-wishlist-attached', 'true');

      var handleMatch = link.getAttribute('href').match(/\/products\/([a-zA-Z0-9\-_%]+)/);
      if (!handleMatch) return;
      var handle = handleMatch[1];

      var computedPosition = window.getComputedStyle(card).position;
      if (computedPosition === 'static') card.style.position = 'relative';

      var btn = createHeartButton('mh-wishlist-btn--card');
      card.appendChild(btn);

      fetchProductByHandle(handle).then(function (product) {
        if (!product) return;
        btn.setAttribute('data-product-id', product.id);
        setButtonState(btn, isInWishlist(product.id));

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleWishlistItem(productToWishlistItem(product, link.getAttribute('href')), btn);
        });
      });
    });
  }

  /* ---- Inject "Add to wishlist" button on product page ---- */
  function injectProductPageButton() {
    if (!/\/products\//.test(window.location.pathname)) return;
    if (document.querySelector('[data-mh-wishlist-pdp]')) return;

    var targetSelectors = [
      '.product-form__buttons',
      'product-form .product-form__buttons',
      'form[action*="/cart/add"] .product-form__buttons',
      'form[action*="/cart/add"]'
    ];
    var target = null;
    for (var i = 0; i < targetSelectors.length; i++) {
      target = document.querySelector(targetSelectors[i]);
      if (target) break;
    }
    if (!target) return;

    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var btn = createHeartButton('mh-wishlist-btn--pdp');
        btn.setAttribute('data-mh-wishlist-pdp', '');
        btn.setAttribute('data-product-id', product.id);
        var textSpan = document.createElement('span');
        textSpan.setAttribute('data-mh-wishlist-pdp-text', '');
        btn.appendChild(textSpan);

        setButtonState(btn, isInWishlist(product.id));

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          toggleWishlistItem(productToWishlistItem(product, window.location.pathname), btn);
        });

        target.parentNode.insertBefore(btn, target.nextSibling);
      })
      .catch(function () {});
  }

  /* ---- Wire up the wishlist icon that's now hard-coded into
     header-actions.liquid (renders inside Horizon's native mobile/tablet
     header; hidden on desktop because the whole .header-section is
     display:none there via our CSS). It already exists in the DOM on
     page load, so we just need to attach behavior to it once. ---- */
  function initMobileWishlistIcon() {
    var mobileBtn = document.querySelector('[data-mh-mobile-wishlist]');
    if (!mobileBtn || mobileBtn.hasAttribute('data-mh-wishlist-bound')) return;
    mobileBtn.setAttribute('data-mh-wishlist-bound', 'true');
    mobileBtn.setAttribute('aria-label', TEXT.addLabel);
    mobileBtn.style.setProperty('--mh-mobile-hover', TEXT.hoverColor || '#f5b400');

    mobileBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openWishlist();
    });

    refreshWishlistUI();
  }

  /* ---- Watch for dynamically loaded content (filters, infinite scroll,
     quick view, or a header-drawer that renders slightly after initial
     paint) and re-run injectors as needed. ---- */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) injectCardButtons(node);
      });
    });
    initMobileWishlistIcon();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* ---- Init ---- */
  injectCardButtons(document);
  injectProductPageButton();
  initMobileWishlistIcon();
  refreshWishlistUI();
})();